import Remit from './remit'

export default Remit
